import { useState } from 'react'
import { Link } from 'react-router-dom'
import { captureEmail, queueCalcEmail } from '../lib/capture.js'

/*
 * Result-moment email capture (logged-out users). Email-first: the low-friction
 * ask is "email me this calculation" (transactional); the promo checkbox is a
 * separate, unchecked opt-in; creating an account is the secondary upsell. Sits
 * where the signup prompt was so the two don't compete.
 */
const CONSENT_TEXT = 'Email me occasional product offers and deals (optional)'
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/

export default function EmailCapture({ payload, pendingCalc }) {
  const [email, setEmail] = useState('')
  const [marketing, setMarketing] = useState(false)
  const [state, setState] = useState('idle') // idle | busy | done | error
  const [msg, setMsg] = useState('')

  const submit = async (e) => {
    e.preventDefault()
    const clean = email.trim()
    if (!EMAIL_RE.test(clean)) { setState('error'); setMsg('Enter a valid email address.'); return }
    setState('busy'); setMsg('')
    const cap = await captureEmail({ email: clean, marketing, source: 'calc', consentText: marketing ? CONSENT_TEXT : null })
    if (cap?.error) { setState('error'); setMsg(cap.error); return }
    await queueCalcEmail(clean, payload || {})
    setState('done')
    setMsg(marketing
      ? 'On its way — check your inbox, and confirm the offers link to get deals.'
      : 'On its way — check your inbox.')
  }

  if (state === 'done') {
    return (
      <div className="email-capture ec-done">
        <div className="ec-check" aria-hidden>✓</div>
        <div className="ec-done-title">Sent!</div>
        <p className="ec-done-sub">{msg}</p>
        <Link to="/register" state={{ calc: pendingCalc }} className="ec-alt">
          Create a free account to save it &amp; get dose reminders →
        </Link>
      </div>
    )
  }

  return (
    <div className="email-capture">
      <div className="ec-title">📧 Email me this calculation</div>
      <form onSubmit={submit} className="ec-form">
        <input
          className="input" type="email" inputMode="email" autoComplete="email"
          placeholder="you@email.com" aria-label="Your email"
          value={email} onChange={(e) => { setEmail(e.target.value); if (state === 'error') setState('idle') }}
        />
        <button className="btn btn-primary" type="submit" disabled={state === 'busy'}>
          {state === 'busy' ? 'Sending…' : 'Send it'}
        </button>
      </form>
      <label className="ec-opt">
        <input type="checkbox" checked={marketing} onChange={(e) => setMarketing(e.target.checked)} />
        <span>{CONSENT_TEXT}</span>
      </label>
      {state === 'error' && <div className="form-error" style={{ marginTop: 6 }}>{msg}</div>}
      <Link to="/register" state={{ calc: pendingCalc }} className="ec-alt">
        Or create a free account to save it &amp; get dose reminders →
      </Link>
    </div>
  )
}
